import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M6.15006 11.15L4.45006 12.85C4.35006 12.94 4.31006 13.07 4.31006 13.2C4.31006 13.33 4.35006 13.46 4.45006 13.55C4.65006 13.75 4.96006 13.75 5.16006 13.55L6.01006 12.7V17.5C6.01006 17.78 6.23006 18 6.51006 18H12.5001C12.7801 18 13.0001 17.78 13.0001 17.5C13.0001 17.22 12.7801 17 12.5001 17H7.01006V12.71L7.85006 13.55C8.05006 13.75 8.36006 13.75 8.56006 13.55C8.75006 13.36 8.75006 13.04 8.56006 12.85L6.92006 11.22C6.91006 11.2 6.88006 11.17 6.86006 11.15C6.66006 10.95 6.35006 10.95 6.15006 11.15V11.15Z"
      fill="currentColor"
    />
    <path
      d="M8.49609 10H4.49609C3.66909 10 2.99609 9.327 2.99609 8.5V4.5C2.99609 3.673 3.66909 3 4.49609 3H8.49609C9.32309 3 9.99609 3.673 9.99609 4.5V8.5C9.99609 9.327 9.32309 10 8.49609 10ZM4.49609 4C4.22009 4 3.99609 4.224 3.99609 4.5V8.5C3.99609 8.776 4.22009 9 4.49609 9H8.49609C8.77209 9 8.99609 8.776 8.99609 8.5V4.5C8.99609 4.224 8.77209 4 8.49609 4H4.49609V4Z"
      fill="currentColor"
    />
    <path
      d="M19.4961 21H15.4961C14.6691 21 13.9961 20.327 13.9961 19.5V15.5C13.9961 14.673 14.6691 14 15.4961 14H19.4961C20.3231 14 20.9961 14.673 20.9961 15.5V19.5C20.9961 20.327 20.3231 21 19.4961 21ZM15.4961 15C15.2211 15 14.9961 15.225 14.9961 15.5V19.5C14.9961 19.775 15.2211 20 15.4961 20H19.4961C19.7711 20 19.9961 19.775 19.9961 19.5V15.5C19.9961 15.225 19.7711 15 19.4961 15H15.4961V15Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'ParentOutline');

export default Icon;
